// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c20Jo22Nps3N8AM0Minv{background:var(--gray-a-15);border-radius:6px;align-items:center;gap:6px;height:22px;padding-left:8px;padding-right:8px;display:flex}.U_vya0JWckgRkemhHJnU{text-transform:capitalize;align-items:center;gap:4px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `c20Jo22Nps3N8AM0Minv`,
	"title": `U_vya0JWckgRkemhHJnU`
};
export default ___CSS_LOADER_EXPORT___;
